import { useEffect, useRef, useState } from 'react';

// Small (?) icon. Clicking toggles a popover with `title` + `body` text.
// Closes on outside click or Escape.
export default function InfoBadge({ title, body, side = 'right' }) {
  const [open, setOpen] = useState(false);
  const wrap = useRef(null);

  useEffect(() => {
    if (!open) return;
    const onDoc = (e) => { if (wrap.current && !wrap.current.contains(e.target)) setOpen(false); };
    const onEsc = (e) => { if (e.key === 'Escape') setOpen(false); };
    document.addEventListener('mousedown', onDoc);
    document.addEventListener('keydown', onEsc);
    return () => {
      document.removeEventListener('mousedown', onDoc);
      document.removeEventListener('keydown', onEsc);
    };
  }, [open]);

  return (
    <span ref={wrap} className="relative inline-flex">
      <button
        type="button"
        aria-label={`Info: ${title}`}
        onClick={(e) => { e.preventDefault(); e.stopPropagation(); setOpen(v => !v); }}
        className="w-4 h-4 rounded-full bg-slate-200 hover:bg-gold/40 text-[10px] font-bold text-navy flex items-center justify-center align-middle ml-1 transition"
      >
        ?
      </button>
      {open && (
        <span
          className={`absolute z-20 ${side === 'right' ? 'left-6 top-0' : 'right-6 top-0'} w-72 max-w-[90vw] card card-pad p-3 text-left shadow-2xl border border-gold/40`}
          style={{ pointerEvents: 'auto' }}
        >
          <div className="text-[11px] uppercase tracking-widest text-gold-600 font-semibold mb-1">{title}</div>
          <div className="text-xs text-ink leading-relaxed whitespace-pre-wrap">{body}</div>
        </span>
      )}
    </span>
  );
}
